import {
  Box,
  Button,
  Chip,
  Typography,
  Divider,
  CircularProgress,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import MaleIcon from "@mui/icons-material/Male";
import FemaleIcon from "@mui/icons-material/Female";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import FmdGoodIcon from "@mui/icons-material/FmdGood";
import { Link, useNavigate } from "react-router-dom";
import MailIcon from "@mui/icons-material/Mail";
import GridViewIcon from "@mui/icons-material/GridView";
import LoginIcon from "@mui/icons-material/Login";
import StoreIcon from "@mui/icons-material/Store";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import { differenceInDays, differenceInMonths, differenceInYears } from "date-fns";
import InquireDialog from "./InquireDialog";
import ReviewModal from "../serviceListings/ReviewModal";
import { connect } from "react-redux";
import * as Actions from "../../redux/actions";
import axios from "axios";
import config from "../../config";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";

const InfoRow = ({ label, children }) => (
  <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", py: 1, borderBottom: "1px solid #222" }}>
    <Typography sx={{ color: "#666", fontSize: "13px", fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.5px", flexShrink: 0, mr: 2 }}>
      {label}
    </Typography>
    <Box sx={{ textAlign: "right" }}>{children}</Box>
  </Box>
);

const ListDetailsCard = ({ listData, seller, jwtToken, user, store, loadStore }) => {
  const [open, setOpen] = useState(false);
  const [conversationId, setConversationId] = useState(null);
  const [openSucessAlert, setOpenSucessAlert] = useState(false);
  const [openReviewDialog, setOpenReviewDialog] = useState(false);
  const [hideInquireToBuy, setIsHideInquireToBuy] = useState(false);
  const [loading, setLoading] = useState(false);
  const [snackbarStates, setSnackbarStates] = useState({ open: false, message: "", severity: "info" });
  const navigate = useNavigate();

  const calculateAge = (birthDay) => {
    const today = new Date();
    const birthDate = new Date(birthDay);
    return {
      years: differenceInYears(today, birthDate),
      months: differenceInMonths(today, birthDate) % 12,
      days: differenceInDays(today, birthDate) % 30,
    };
  };

  const formatDate = (d) => {
    const date = new Date(d);
    return `${date.getUTCDate().toString().padStart(2, "0")}/${(date.getUTCMonth() + 1).toString().padStart(2, "0")}/${date.getUTCFullYear()}`;
  };

  const d = {
    sex: listData.sex,
    color: listData.color,
    traits: listData.traits,
    weight: listData.weight,
    height: listData.height,
    length: listData.length,
    birth: listData.birth,
    age: calculateAge(listData.birth),
    diet: listData.diet,
    breedName: listData.breed?.name,
    categoryName: listData.category?.name,
    img: listData.seller?.store?.brand_logo?.url,
    store: listData.seller?.store,
    brandName: listData.seller?.store?.brand_name,
    location: listData.seller?.store?.location,
    shippingType: listData.seller?.store?.delivery_option,
    maxPrice: listData.seller?.store?.max_price != null ? parseFloat(listData.seller?.store?.max_price).toFixed(2) : null,
    minPrice: listData.seller?.store?.min_price != null ? parseFloat(listData.seller?.store?.min_price).toFixed(2) : null,
    shipping: listData.shipping_details,
    firstPosted: formatDate(listData.first_posted),
    lastUpdated: formatDate(listData.last_updated),
    storeId: listData.seller?.store?.id,
    sellerId: listData.seller?.id,
    userId: listData.seller?.user?.id,
    categoryId: listData.category_id,
    listingId: listData.id,
    status: listData.status,
    price: listData.price,
  };

  useEffect(() => {
    if (seller) loadStore({ storeId: d.storeId });
  }, [d.storeId]);

  useEffect(() => {
    if (store) {
      const ids = store.trophy_cases.map((t) => t.listing_animal_id);
      setIsHideInquireToBuy(ids.includes(d.listingId) && d.status === "nfs");
    }
  }, [store]);

  useEffect(() => {
    const getConversation = async () => {
      setLoading(true);
      try {
        const res = await axios.post(
          `${config.SERVER_URL}/conversations/check_existing_conversation`,
          { conversation: { listing_id: d.listingId } },
          { headers: { "Content-Type": "application/json", Authorization: `Bearer ${jwtToken}` } }
        );
        if (res.status === 200 && res.data.conversation_sid !== null) {
          setConversationId(res.data.conversation_sid);
        }
      } catch (e) {}
      setLoading(false);
    };
    getConversation();
  }, [d.listingId, jwtToken, openSucessAlert]);

  const handleOpen = () => {
    if (conversationId !== null) {
      navigate("/conversations", { state: { conversationId } });
    } else {
      setOpen(true);
    }
  };

  const statusConfig = {
    sold: { label: "SOLD", bg: "#EF0107", color: "#fff" },
    nfs: { label: "NOT FOR SALE", bg: "#333", color: "#aaa" },
    on_hold: { label: "ON HOLD", bg: "#FFD300", color: "#000" },
  };
  const statusKey = listData.on_hold ? "on_hold" : d.status;
  const status = statusConfig[statusKey];

  return (
    <>
      <Snackbar open={openSucessAlert} autoHideDuration={3000} onClose={() => setOpenSucessAlert(false)} anchorOrigin={{ vertical: "bottom", horizontal: "right" }}>
        <MuiAlert elevation={6} variant="filled" onClose={() => setOpenSucessAlert(false)} severity="success">Message Sent Successfully!</MuiAlert>
      </Snackbar>
      <Snackbar open={snackbarStates.open} autoHideDuration={3000} onClose={() => setSnackbarStates({ ...snackbarStates, open: false })} anchorOrigin={{ vertical: "bottom", horizontal: "right" }}>
        <MuiAlert elevation={6} variant="filled" severity={snackbarStates.severity} onClose={() => setSnackbarStates({ ...snackbarStates, open: false })}>{snackbarStates.message}</MuiAlert>
      </Snackbar>

      {loading ? (
        <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
          <CircularProgress sx={{ color: "#FFC001" }} />
        </Box>
      ) : (
        <>
          <InquireDialog open={open} brandName={d.brandName} listData={listData} setOpen={setOpen} setOpenSucessAlert={setOpenSucessAlert} />
          <ReviewModal open={openReviewDialog} brandName={d.brandName} listData={listData} setOpen={setOpenReviewDialog} setReviewOpenSucessAlert={() => {}} setSnackbarStates={setSnackbarStates} setReviewOpenSucessAlertText={() => {}} />

          <Box sx={{ display: "flex", flexDirection: "column", gap: 2, height: "100%", overflowY: "auto" }}>

            {/* Title + status */}
            <Box>
              <Box sx={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", gap: 1, mb: 1 }}>
                <Typography sx={{ color: "#fff", fontWeight: 800, fontSize: { xs: "22px", md: "28px" }, lineHeight: 1.2 }}>
                  {listData.name}
                </Typography>
                {status && (
                  <Chip label={status.label} size="small" sx={{ backgroundColor: status.bg, color: status.color, fontWeight: 700, fontSize: "11px", flexShrink: 0 }} />
                )}
              </Box>
              <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
                <Chip label={d.categoryName} size="small" sx={{ backgroundColor: "rgba(255,192,1,0.12)", color: "#FFC001", fontWeight: 600, fontSize: "11px", border: "1px solid rgba(255,192,1,0.3)" }} />
                {d.breedName && (
                  <Chip label={d.breedName} size="small" sx={{ backgroundColor: "#1e1e1e", color: "#888", fontWeight: 500, fontSize: "11px", border: "1px solid #2a2a2a" }} />
                )}
              </Box>
            </Box>

            {/* Price */}
            <Box sx={{ backgroundColor: "#1a1a1a", border: "1px solid #2a2a2a", borderRadius: "12px", px: 2.5, py: 2 }}>
              <Typography sx={{ color: "#666", fontSize: "11px", fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.5px", mb: 0.5 }}>Price</Typography>
              <Typography sx={{ color: "#FFC001", fontWeight: 800, fontSize: { xs: "28px", md: "36px" }, lineHeight: 1 }}>
                ${Number(d.price).toLocaleString()}
              </Typography>
              <Typography sx={{ color: "#555", fontSize: "12px", mt: 0.5 }}>USD · Payments accepted</Typography>
            </Box>

            {/* Details */}
            <Box sx={{ backgroundColor: "#1a1a1a", border: "1px solid #2a2a2a", borderRadius: "12px", px: 2, py: 0.5 }}>
              {d.sex && (
                <InfoRow label="Sex">
                  <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                    {d.sex === "male" ? <MaleIcon sx={{ color: "#4da6ff", fontSize: 18 }} /> : d.sex === "female" ? <FemaleIcon sx={{ color: "#ff69b4", fontSize: 18 }} /> : <><MaleIcon sx={{ color: "#4da6ff", fontSize: 16 }} /><FemaleIcon sx={{ color: "#ff69b4", fontSize: 16 }} /></>}
                    <Typography sx={{ color: "#ccc", fontSize: "14px", textTransform: "capitalize" }}>{d.sex}</Typography>
                  </Box>
                </InfoRow>
              )}
              {d.birth && (
                <InfoRow label="Birth">
                  <Typography sx={{ color: "#ccc", fontSize: "14px" }}>{formatDate(d.birth)}</Typography>
                </InfoRow>
              )}
              {d.age && (
                <InfoRow label="Age">
                  <Typography sx={{ color: "#ccc", fontSize: "14px" }}>
                    {d.age.years > 0 && `${d.age.years}y `}{d.age.months > 0 && `${d.age.months}m `}{d.age.days > 0 && `${d.age.days}d`}
                  </Typography>
                </InfoRow>
              )}
              {d.color && <InfoRow label="Color"><Typography sx={{ color: "#ccc", fontSize: "14px" }}>{d.color}</Typography></InfoRow>}
              {d.weight && <InfoRow label="Weight"><Typography sx={{ color: "#ccc", fontSize: "14px" }}>{d.weight}</Typography></InfoRow>}
              {d.height && <InfoRow label="Height"><Typography sx={{ color: "#ccc", fontSize: "14px" }}>{d.height}</Typography></InfoRow>}
              {d.length && <InfoRow label="Length"><Typography sx={{ color: "#ccc", fontSize: "14px" }}>{d.length}</Typography></InfoRow>}
              {d.diet && <InfoRow label="Diet"><Typography sx={{ color: "#ccc", fontSize: "14px" }}>{d.diet}</Typography></InfoRow>}
              {d.traits?.length > 0 && (
                <InfoRow label="Traits">
                  <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5, justifyContent: "flex-end" }}>
                    {d.traits.map((t) => (
                      <Chip key={t} label={t} size="small" sx={{ backgroundColor: "rgba(255,192,1,0.15)", color: "#FFC001", fontWeight: 600, fontSize: "11px" }} />
                    ))}
                  </Box>
                </InfoRow>
              )}
              <InfoRow label="Shipping">
                <Typography sx={{ color: "#ccc", fontSize: "14px" }}>
                  {d.maxPrice && d.minPrice ? `$${d.minPrice} – $${d.maxPrice}` : d.maxPrice ? `Max $${d.maxPrice}` : d.minPrice ? `From $${d.minPrice}` : "Inquire from store"}
                  {" "}<Typography component="span" sx={{ color: "#555", fontSize: "12px" }}>(Domestic)</Typography>
                </Typography>
              </InfoRow>
              <InfoRow label="Posted"><Typography sx={{ color: "#555", fontSize: "13px" }}>{d.firstPosted}</Typography></InfoRow>
              <InfoRow label="Updated"><Typography sx={{ color: "#555", fontSize: "13px" }}>{d.lastUpdated}</Typography></InfoRow>
            </Box>

            {/* Seller/Store */}
            {d.store && (
              <Box
                component={Link}
                to={"/neighbour/" + d.storeId}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 2,
                  backgroundColor: "#1a1a1a",
                  border: "1px solid #2a2a2a",
                  borderRadius: "12px",
                  p: 2,
                  textDecoration: "none",
                  transition: "all 0.25s ease",
                  "&:hover": { borderColor: "#FFC001" },
                }}
              >
                {d.img && (
                  <Box sx={{ width: 56, height: 56, borderRadius: "10px", overflow: "hidden", border: "1px solid #333", flexShrink: 0, backgroundColor: "#000" }}>
                    <img src={d.img} alt={d.brandName} style={{ width: "100%", height: "100%", objectFit: "contain" }} />
                  </Box>
                )}
                <Box sx={{ flex: 1, minWidth: 0 }}>
                  <Typography sx={{ color: "#FFC001", fontWeight: 700, fontSize: "15px" }} noWrap>{d.brandName}</Typography>
                  {d.location && (
                    <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, mt: 0.3 }}>
                      <FmdGoodIcon sx={{ color: "#555", fontSize: 14 }} />
                      <Typography sx={{ color: "#777", fontSize: "13px" }} noWrap>{d.location}</Typography>
                    </Box>
                  )}
                  <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, mt: 0.3 }}>
                    <LocalShippingIcon sx={{ color: "#555", fontSize: 14 }} />
                    <Typography sx={{ color: "#777", fontSize: "13px" }}>
                      {d.shippingType === "regional_pickup" ? "Regional Pickup" : "Local Pickup"}
                    </Typography>
                  </Box>
                </Box>
                <StoreIcon sx={{ color: "#333", fontSize: 20, flexShrink: 0 }} />
              </Box>
            )}

            {/* Action buttons */}
            <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
              {!user && (
                <Button fullWidth variant="contained" startIcon={<LoginIcon />} onClick={() => navigate("/auth/login")}
                  sx={{ backgroundColor: "#FFC001", color: "#000", fontWeight: 700, fontSize: "15px", textTransform: "none", borderRadius: "10px", py: 1.3, "&:hover": { backgroundColor: "#e6ac00" } }}>
                  Login / Sign Up to Inquire
                </Button>
              )}
              {user && user.id !== d.userId && !hideInquireToBuy && (
                <Button fullWidth variant="contained" startIcon={<MailIcon />} onClick={handleOpen}
                  sx={{ backgroundColor: "#FFC001", color: "#000", fontWeight: 700, fontSize: "15px", textTransform: "none", borderRadius: "10px", py: 1.3, "&:hover": { backgroundColor: "#e6ac00" } }}>
                  {conversationId ? "Go to Conversation" : "Inquire to Buy"}
                </Button>
              )}
              {conversationId && (
                <Button fullWidth variant="outlined" startIcon={<BorderColorIcon />} onClick={() => setOpenReviewDialog(true)}
                  sx={{ borderColor: "#FFC001", color: "#FFC001", fontWeight: 700, fontSize: "14px", textTransform: "none", borderRadius: "10px", py: 1.2, "&:hover": { backgroundColor: "rgba(255,192,1,0.08)" } }}>
                  Review Seller
                </Button>
              )}
              <Button fullWidth component={Link} to={"/listings/classes/" + d.categoryId} variant="outlined" startIcon={<GridViewIcon />}
                sx={{ borderColor: "#333", color: "#ccc", fontWeight: 600, fontSize: "14px", textTransform: "none", borderRadius: "10px", py: 1.1, "&:hover": { borderColor: "#FFC001", color: "#FFC001" } }}>
                More Like This
              </Button>
              {d.storeId && (
                <Button fullWidth component={Link} to={"/listings/seller/" + d.sellerId} variant="outlined" startIcon={<StoreIcon />}
                  sx={{ borderColor: "#333", color: "#ccc", fontWeight: 600, fontSize: "14px", textTransform: "none", borderRadius: "10px", py: 1.1, "&:hover": { borderColor: "#FFC001", color: "#FFC001" } }}>
                  More from This Store
                </Button>
              )}
            </Box>
          </Box>
        </>
      )}
    </>
  );
};

const mapStateToProps = ({ Seller, Auth, Store }) => ({
  seller: Seller.seller,
  jwtToken: Auth.jwtToken,
  user: Auth.user,
  store: Store.store,
});

const mapDispatchToProps = (dispatch) => ({
  loadStore: (storeId) => dispatch(Actions.thunkGetStore(storeId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ListDetailsCard);
